import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["item", "filter"]

  connect() {
    this.filterItems()
  }

  filterItems() {
    console.log("filterItems")
    const filters = this.filterTargets
    const items = this.itemTargets

    let selectedFilters = {}

    filters.forEach((filter) => {
      if (filter.checked) {
        const name = filter.name
        selectedFilters[name] = filter.value
      }
    })

    console.log(selectedFilters)

    items.forEach((item) => {
      let show = true
      for (let key in selectedFilters) {
        console.log(item.dataset);
        if (item.dataset[key] !== selectedFilters[key]) {
          show = false
          break
        }
      }
      item.classList.toggle("hidden", !show)
    })
  }
}
